<template>
  <div class="asc-add-plot-to-issue-dialog">
    <asc-dialog
      text="Add Plot Instance to Mx & Alerts"
      :show-dialog="showDialog"
      :on-close="handleClose"
      :width="542"
      :on-primary="handlePrimaryClick"
      :primary-button-text="getPrimaryButtonText"
    >
      <template v-if="showDialog">
        <p>
          Add this plot instance to an Mx &amp; Alert page. Select Mx &amp;
          Alerts ID rows from the table and click 'Apply.'
        </p>
        <asc-spinner-wrapper :loading="loading">
          <asc-plot-to-issues-grid
            :values="issues"
            :full-columns="true"
            :on-selection-changed="handleSelectionChanged"
            grid-filters
            :selected-issues="innerVal"
          ></asc-plot-to-issues-grid>
        </asc-spinner-wrapper>
      </template>
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscPlotToIssuesGrid from '@/components/molecules/AscPlotToIssuesGrid'

export default {
  name: 'AscAddPlotToIssueDialog',

  components: {
    AscDialog,
    AscSpinnerWrapper,
    AscPlotToIssuesGrid,
  },

  mixins: [AscDialogMixin],

  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    issues: {
      type: Array,
      default: () => [],
    },
    selectedIssues: {
      type: Array,
      default: () => [],
    },
    onApply: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      innerVal: this.selectedIssues || [],
    }
  },
  computed: {
    getPrimaryButtonText() {
      return this.issues && this.issues.length ? 'apply' : 'close'
    },
  },

  watch: {
    selectedIssues(val) {
      this.innerVal = val || []
    },
  },

  methods: {
    handleSelectionChanged(rows) {
      this.innerVal = rows
    },
    handlePrimaryClick() {
      if (this.onApply && this.issues && this.issues.length)
        this.onApply(this.innerVal)
      else this.handleClose()
    },
    handleClose() {
      if (this.onClose) {
        this.onClose()
      }
    },
  },
}
</script>

<style lang="scss">
.asc-add-plot-to-issue-dialog {
  p {
    margin-bottom: 37px;
  }
}
</style>
